import React, { useState, useEffect } from "react";
import { getDocs, collection,deleteDoc,doc } from "firebase/firestore";
import { db, auth } from "../../firebase";
import Tnpnav from "./Tnpnav";


export default function Studetails() {
const [joblist, setJoblist] = useState([]);

  const ref = collection(db, "users");
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  },[]);
//   const getjob =  () => {
//     const data =  getDocs(ref);
//     setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
//   };
//   const del=async(id)=>{
//     // await bookServices.deleteBook(id);
//     const jobDoc =  doc(db,"users",id);
//     getjob();
//     return deleteDoc(jobDoc);
    
// }
const getjob = async () => {
    const data = await getDocs(ref);
    setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };
  const del=async(id)=>{
    // await bookServices.deleteBook(id);
    const jobDoc =   doc(db,"users",id);
    const jobDocs =   doc(db,"selected",id);
    // getjob();""
    // deleteDoc(db,"appliedin",id);
   await deleteDoc(jobDoc);
   await deleteDoc(jobDocs);
   alert("Student account deleted successfully")
    
}

  return (
   <>
   <Tnpnav/>
   <table className="tnptable" id="stuTable">
        <thead>
          <tr>
  
            <th>Student Name</th>
            <th>Student Email ID</th>
            <th>Student MIS ID</th>
            <th>Class</th>
            <th>Department</th>
            <th>Roll no</th>
            <th>DELETE STUDENT ACCOUNT</th>
            
            
          </tr>
        </thead>
      {joblist.map((post) => {
        return (
           <>
            <tbody>
                      <tr>
                      <td>{post.name}</td>
            <td>{post.email}</td>
            <td>{post.misid}</td>
            <td>{post.classes}</td>
            <td>{post.department}</td>
            <td>{post.roll}</td>
            <td> <button className="btn-danger btn" onClick={()=>del(post.uid)}>Delete</button></td>
             </tr>
                    </tbody>
            
            <br/>
            </>
        );
      })}
      </table>
   </>
  )
}
